export default {
  computed: {
    inputType() {
      return this.question.inputType || 'text';
    },
  },
};
